import { LanguageProvider } from './LanguageContext';
import Hero from './Hero';
import Gallery from './Gallery';
import About from './About';
import Valencia from './Valencia';
import Invite from './Invite';
import Partners from './Partners';
import Cont from './Cont';
import Collab from './Collab';
import Footer from './Footer';
import LangToggle from './LangToggle';

function App() {
  return (
    <LanguageProvider>
      <LangToggle />
      <Hero />
      <Gallery />
      <About />
      <Valencia />
      <Invite />
      <Partners />
      <Cont />
      <Collab />
      <Footer />
    </LanguageProvider>
  );
}

export default App;